'use strict';
import * as $j_app$002edata$002etypes$005fpharmacy$0024package$0024$002dPharmacy$002dName$0024 from "./app.data.types_pharmacy$package$-Pharmacy-Name$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_PharmacyDetails$$anon$6() {
}
export { $c_Lapp_api_PharmacyDetails$$anon$6 as $c_Lapp_api_PharmacyDetails$$anon$6 };
$c_Lapp_api_PharmacyDetails$$anon$6.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_PharmacyDetails$$anon$6.prototype.constructor = $c_Lapp_api_PharmacyDetails$$anon$6;
/** @constructor */
function $h_Lapp_api_PharmacyDetails$$anon$6() {
}
export { $h_Lapp_api_PharmacyDetails$$anon$6 as $h_Lapp_api_PharmacyDetails$$anon$6 };
$h_Lapp_api_PharmacyDetails$$anon$6.prototype = $c_Lapp_api_PharmacyDetails$$anon$6.prototype;
$c_Lapp_api_PharmacyDetails$$anon$6.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_PharmacyDetails$$anon$6.prototype.apply__Lsttp_tapir_Schema = (function() {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype\uff3ftapir$package$();
  var \u03b4proxy3 = $j_app$002edata$002etypes$005fpharmacy$0024package$0024$002dPharmacy$002dName$0024.$m_Lapp_data_types\uff3fpharmacy$package$PharmacyName$();
  return $x_1.newTypeSchema__Lyantl_INewtype__Lsttp_tapir_Schema__Lsttp_tapir_Schema(\u03b4proxy3, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForString);
});
$c_Lapp_api_PharmacyDetails$$anon$6.prototype.apply__O = (function() {
  return this.apply__Lsttp_tapir_Schema();
});
var $d_Lapp_api_PharmacyDetails$$anon$6 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_PharmacyDetails$$anon$6, "app.api.PharmacyDetails$$anon$6", ({
  Lapp_api_PharmacyDetails$$anon$6: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_PharmacyDetails$$anon$6 as $d_Lapp_api_PharmacyDetails$$anon$6 };
//# sourceMappingURL=app.api.-Pharmacy-Details$$anon$6.js.map
